<template>
  <custom-dialog width="448px" :title="model.title" class="area-item-dialog" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_area_item_dialog.sjxzq')" v-if="!isTopLevel">
              <custom-select type="tree" v-model="form.parentId" url="NationRegionTree" :props="props" ref="area" :dataFilter="parentFilter"></custom-select>
            </el-form-item>
            <el-form-item :label="$t('base_area_item_dialog.ming_cheng')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base_area_item_dialog.jian_cheng')" prop="shortName">
              <el-input v-model="form.shortName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base_area_item_dialog.dai_ma')" prop="code">
              <el-input v-model="form.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base_area_item_dialog.xian_shi_shun_xu')" prop="sort">
              <el-input type="number" min="0" v-model.number="form.sort"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Common.com_status')">
              <custom-select v-model="form.status" code="cloud_common_state" valueType="number"></custom-select>
            </el-form-item>
            <el-form-item :label="$t('base_area_item_dialog.zi_mu_dai_ma')">
              <el-input v-model="form.firstLetter"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

const statusDefault = 1;

export default {
  mixins: [dialogMixins],
  props: {
    nationRegionId: String,
    // add | edit
    type: {
      type: String,
      default: 'add',
    },
    // 是否为顶级区域-例如：中国
    isTopLevel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // const context = this;
    return {
      form: {
        // 上级区域
        parentId: '',
        // 区域名称
        name: '',
        // 编码
        code: '',
        // 区域简称
        shortName: '',
        // 显示顺序
        sort: 0,
        // 状态
        status: statusDefault,
        // 字母代码
        firstLetter: '',
      },
      props: {
        label: 'name',
        value: 'nationRegionId',
        checkStrictly: true,
      },
    };
  },
  computed: {
    rules() {
      return {
        name: {
          type: 'string',
          max: 50,
          message: this.$t('Common.com_rules_length_max', [50]),
        },
        code: {
          type: 'string',
          max: 30,
          message: this.$t('Common.com_rules_length_max', [30]),
        },
        shortName: {
          type: 'string',
          max: 10,
          message: this.$t('Common.com_rules_length_max', [10]),
        },
        sort: {
          type: 'number',
          min: 0,
          message: this.$t('Common.com_rules_number_min', [0]),
        },
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 过滤规则：不能选当前区域作为上级区域 -todo ,发现删除了节点后，父级不会显示
    parentFilter(list) {
      this.delCurArea(list, this.nationRegionId);

      return list;
    },
    // 在tree中，删除当前区域 - 使用disabled
    delCurArea(list, curAreaNationRegionId) {
      const targetIndex = list.findIndex((item) => item.nationRegionId === curAreaNationRegionId);
      if (targetIndex >= 0) {
        list[targetIndex].disabled = true;
      } else {
        // 如果没有找到，则递归
        list.forEach((item) => {
          if (item.children && item.children.length) {
            this.delCurArea(item.children, curAreaNationRegionId);
          }
        });
      }
    },
    getCreateReqData() {
      const ret = {
        ...this.form,
      };
      const area = this.form.parentId;
      if (area.length) {
        if (Array.isArray(area)) {
          ret.parentId = area[area.length - 1];
        } else {
          ret.parentId = area;
        }
      }
      return ret;
    },
    getEditReqData() {
      const ret = this.getCreateReqData();
      ret.nationRegionId = this.nationRegionId;
      return ret;
    },
    getInfo() {
      this.$getJSON(apis.NationRegionInfo, {
        nationRegionId: this.nationRegionId,
      }).then(({ data }) => {
        this.form = data;
        this.form.sort = this.form.sort || 0;
        this.form.status = this.form.status === undefined ? statusDefault : this.form.status;
      });
    },
    init() {
      if (this.type === 'edit') {
        this.getInfo();
      }
    },
    create() {
      this.$refs.form.validate((val) => {
        if (val) {
          const reqData = this.getCreateReqData();
          this.$postJSON(apis.NationRegionAdd, reqData, true).then(() => {
            this.$message({
              message: this.$t('Common.com_add_success'),
              type: 'success',
            });
            this.closeDialog();
            this.$emit('create');
          });
        }
      });
    },
    edit() {
      this.$refs.form.validate((val) => {
        if (val) {
          const reqData = this.getEditReqData();
          this.$postJSON(apis.NationRegionUpdate, reqData, true).then(() => {
            this.$message({
              message: this.$t('Common.com_add_success'),
              type: 'success',
            });
            this.closeDialog();
            this.$emit('edit');
          });
        }
      });
    },
    onConfirm() {
      if (this.type === 'edit') {
        this.edit();
      } else {
        this.create();
      }
    },
    closeDialog() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.area-item-dialog {
  .el-form-item__label {
    text-align: left;
    width: 100% !important;
  }
  .el-select,
  .el-cascader {
    width: 100%;
  }
}
</style>
